import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/calendar/events")({
	component: RouteComponent,
});

function RouteComponent() {
	return <Outlet />;
}
